/* eslint-disable camelcase */
import { action } from '@ember/object';
import { confirmSetupIntent } from 'client-portal/utils/stripe-payment-methods';
import { error } from 'client-portal/utils/banners';
import { task } from 'ember-concurrency';
import Service, { service } from '@ember/service';

export default class StripeAchService extends Service {
  @service store;
  @service session;
  @service stripe;
  @service analytics;
  @service intl;

  @action
  createAchAccount() {
    return this.store.createRecord('stripe-ach-bank-account');
  }

  analyticsErrorTracking(message) {
    this.analytics.track('Client Payment Method Added', {
      object: 'Client Payment Method',
      action: 'Added',
      initiator: 'User',
      from: 'New ACH',
      'is_mobile_app': false,
      errors: [message],
      'sp_client_id': this.session.currentClient.hashedId,
      'added_successfully': false,
      'payment_type': 'Stripe',
    });
  }

  @(task(function* ({ elements, newAchAccount }) {
    let options = {
      paymentMethodTypes: ['us_bank_account'],
      paymentMethodOptions: {
        us_bank_account: {
          verification_method: 'instant',
        },
      },
    };

    if (this.session.currentClient) {
      options.client = this.session.currentClient;
    }

    let newSetupIntent = this.store.createRecord('stripe-setup-intent', options);
    yield newSetupIntent.save();

    let setupIntentConfirmation = yield confirmSetupIntent(
      newSetupIntent,
      { elements, stripe: this.stripe.stripe },
      {
        errorTracking: this.analyticsErrorTracking.bind(this),
        paymentMethodType: 'ACH',
        intl: this.intl,
      }
    );

    if (!setupIntentConfirmation) return;

    if (setupIntentConfirmation.status === 'requires_payment_method') {
      return this.handleSetupConfirmationError(setupIntentConfirmation);
    }

    let { payment_method: paymentMethod } = setupIntentConfirmation;
    let { us_bank_account: usBankAccount } = paymentMethod;

    newAchAccount.setProperties({
      stripeCustomerId: paymentMethod.customer,
      bankName: usBankAccount?.bank_name,
      accountNumberLast4: usBankAccount?.last4,
      accountType: usBankAccount?.account_type,
      stripePaymentMethodId: paymentMethod.id,
    });

    yield newAchAccount.save();

    return newAchAccount;
  }).drop())
  addAchPaymentMethodTask;

  handleSetupConfirmationError(setupIntentConfirmation) {
    let message =
      setupIntentConfirmation.last_setup_error?.message ||
      this.intl.t('billing.paymentMethods.achVerificationError');
    error({ title: message });
  }
}
